import { TFunction } from 'i18next';

import { createSchema, createValidation } from '~/utils/validator';

export const learnerTeamFormSchema = (t: TFunction) =>
  createSchema({
    team: createValidation().required(t('error.fieldRequired')),
  });
